export const contingentExternalLinkIcon = {
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path d="M3.5 8.5l5-5M5 3l1.672-1.672a2.829 2.829 0 014 0v0a2.829 2.829 0 010 4L9 7M3 5L1.328 6.672a2.829 2.829 0 000 4v0a2.829 2.829 0 004 0L7 9" stroke="#23AFFF" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'external-link',
};
